import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import companyServices from 'app/services/company-services';
import { normalizeCompanySettings } from 'app/utils/companySettings';
import React, { createContext, useState, useContext, useEffect } from 'react';

// Crea el contexto
const CompanySettingsContext = createContext();

// Crea un Hook personalizado para acceder al contexto más fácilmente
export function useCompanySettings() {
  return useContext(CompanySettingsContext);
}

// Define el Provider
export function CompanySettingsProvider({ children }) {
  const {authUser} = useJumboAuth();
  // const authUser = null;
  const [companySettings, setCompanySettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadCompanySettings = () => {
    if (!authUser?.current_company) {
      setLoading(false);
      return Promise.resolve(null);
    }

    setLoading(true);

    return companyServices.getCompanySettings(authUser.current_company.id)
      .then(data => {
        const normalizedSettings = normalizeCompanySettings(data);
        setCompanySettings(normalizedSettings);
        setError(null);
        return normalizedSettings;
      })
      .catch(function (error) {
        setError(error);
        throw error;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadCompanySettings();
  }, [authUser]); // Ejecuta esto solo una vez al montar el componente

  return (
    <CompanySettingsContext.Provider value={{ companySettings, loading, error, setCompanySettings, reloadCompanySettings: loadCompanySettings }}>
      {children}
    </CompanySettingsContext.Provider>
  );
}
